import moment from "moment";
import React from "react";
import { Link } from "react-router-dom";

const NotificationItem = (props) => {
  const handleReadNotification = () => {
    props.handleClick(props.id);
  };

  return (
    <li className={`shadow-lg rounded border px-5 py-4 ${props.type === "Featured" ? "bg-amber-50 border-amber-300" : "bg-white border-slate-200"}`}>
      <Link
        to="/notifications"
        // to={props.link}
        className="md:flex justify-between items-center space-y-4 md:space-y-0 space-x-2"
      >
        {/* Left side */}
        <div className="flex items-start space-x-3 md:space-x-4">
          <div className="w-9 h-9 shrink-0 mt-1">
            <img className="w-9 h-9 rounded-full" src={props.image} width="36" height="36" alt={props.company} />
          </div>
          <div>
            <h5 className="inline-flex font-semibold text-slate-800">{props.title}</h5>
            <div className="text-sm">{props.details}</div>
          </div>
        </div>
        {/* Right side */}
        <div className="flex flex-row items-center space-x-4 pl-10 md:pl-0">
          <div className="text-sm text-slate-500 italic whitespace-nowrap">{moment(props.date).format("DD/MM/YYYY")}</div>
          <div onClick={handleReadNotification} className="cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
              <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </div>
        </div>
      </Link>
    </li>
  );
};

export default NotificationItem;
